import { FC, useEffect } from "react";
import ModalComponent from "../../shared/base-components/Modal";

import { Col, Row } from "reactstrap";
import { CustomerPaymentHistoryModalProps } from "./CustomerProfile.constants";
import { useCustomerAllPaymentOrdersMutation } from "./CustomerProfile.actions";
import AccordionCollapsePayment from "../../shared/base-components/AccordionCollapse/AccordionCollapsePayment";

const CustomerPaymentHistoryModal: FC<CustomerPaymentHistoryModalProps> = ({
  isModalOpen,
  toggle,
  paymentId,
  mutate,
}) => {
  const { data, mutate: customerAllPaymentOrdersMutation } =
    useCustomerAllPaymentOrdersMutation();

  useEffect(() => {
    customerAllPaymentOrdersMutation({ id: paymentId });
  }, []);

  return (
    <ModalComponent
      scrollable
      header={"Geçmiş Ödemeler"}
      description={""}
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Row>
        {data?.results.length !== 0 ? (
          <Col>
            <AccordionCollapsePayment
              mutate={mutate}
              toggle={toggle}
              accordionList={data}
            />
          </Col>
        ) : (
          <h6>Geçmiş ödeme bulunamadı.</h6>
        )}
      </Row>
    </ModalComponent>
  );
};

export default CustomerPaymentHistoryModal;
